import React from 'react';
import { useTranslation } from 'react-i18next';
import useStore from '../../../store';

import { Trans } from 'react-i18next';

function ModeInfoOverlay({
  store,
}) {

  const { t } = useTranslation();

  const { ref } = store;
  const { info } = ref;
  const { game } = info;

  const modeHelp = game?.modeHelp;

  return (
    <>
      <div className="overlay-background" onClick={() => useStore.setState({ showModeHelp: false })}></div>

      <div className="premium-menu touch-active">
        <div className="premium-item">
            <div className="feature-info">
              <span className="feature-name">{t(`mode.${modeHelp}.name`)}</span>
                <p className="feature-description">
                  <Trans i18nKey={`mode.${modeHelp}.about`}>
                    {t(`mode.${modeHelp}.about`)}
                  </Trans>
                </p>
            </div>
            <button className="wide-button" onClick={() => {
              useStore.setState({ showModeHelp: false });
            }}>
              {t('settings.understand')}
            </button>
          </div>
      </div>
    </>
  );
}

export default ModeInfoOverlay;
